module.exports = __webpack_public_path__ + "img/497f7d9.png";